import { Injectable } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { ConfirmBoxComponent } from "src/app/pages/shared/components/confirm-box/confirm-box.component";
import { Product, ProductStatus } from "../tour.models";
import { Observable, of } from "rxjs";
import { switchMap, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ProductEditConfirmationService {
  constructor(private modalService: BsModalService) {}

  confirmEditPublishedProduct(product: Product): Observable<boolean> {
    return new Observable((observer) => {
      if (product.status !== ProductStatus.PUBLISHED) {
        observer.next(true);
        observer.complete();
        return;
      }

      const title = "Edit Published Product";
      const confirmText =
        "Your product is currently published. Making changes will change its status back to draft and it will no longer be visible to customers until you publish it again. Do you want to continue?";
      const initialState = {
        title,
        confirmText,
        acceptButtonText: "Yes, Continue",
        cancleButtonText: "Cancel",
      };

      const modalRef = this.modalService.show(ConfirmBoxComponent, {
        initialState,
        class: "modal-md",
        backdrop: "static",
        keyboard: false,
      });

      const component: ConfirmBoxComponent = modalRef.content;
      component.callback.subscribe((shouldYes: boolean) => {
        console.log("should yes ", shouldYes);
        observer.next(shouldYes);
        observer.complete();
      });
    });
  }

  executeWithConfirmation(
    product: Product,
    saveOperation: () => Observable<Product>,
  ): Observable<Product | null> {
    return this.confirmEditPublishedProduct(product).pipe(
      switchMap((confirmed) => {
        if (!confirmed) {
          return of(null);
        }
        return saveOperation().pipe(
          map((updatedProduct) => {
            if (product?.status === ProductStatus.PUBLISHED) {
              return { ...updatedProduct, status: ProductStatus.DRAFT };
            }
            return updatedProduct;
          }),
        );
      }),
    );
  }
}
